"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const crypto_1 = require("@iov/crypto");
const encoding_1 = require("@iov/encoding");
const bn_js_1 = __importDefault(require("bn.js"));
const address_1 = require("./address");
class Abi {
    static calculateMethodHash(signature) {
        return new crypto_1.Keccak256(encoding_1.toAscii(signature)).digest();
    }
    static calculateMethodId(signature) {
        return Abi.calculateMethodHash(signature).slice(0, 4);
    }
    static encodeAddress(address) {
        if (!address_1.isValidAddress(address)) {
            throw new Error("Invalid address format");
        }
        const addressBytes = encoding_1.fromHex(address.slice(2));
        return Abi.padTo32(addressBytes);
    }
    static encodeUint256(value) {
        if (!value.match(/^[0-9]+$/)) {
            throw new Error("Invalid string format");
        }
        const numericValue = new bn_js_1.default(value, 10);
        return Uint8Array.from(numericValue.toArray("be", 32));
    }
    static decodeAddress(binary) {
        if (binary.length !== 32) {
            throw new Error("Input data not 256 bit long");
        }
        const firstTwelveBytes = binary.slice(0, 12);
        if (firstTwelveBytes.some((byte) => byte !== 0)) {
            throw new Error("Input data is not zero-padded");
        }
        const lastTwentyBytes = binary.slice(-20);
        return address_1.toChecksummedAddress(lastTwentyBytes);
    }
    static decodeUint256(binary) {
        if (binary.length !== 32) {
            throw new Error("Input data not 256 bit long");
        }
        return new bn_js_1.default(binary).toString();
    }
    /**
     * Decode head-tail encoded data as described in
     * https://medium.com/@hayeah/how-to-decipher-a-smart-contract-method-call-8ee980311603
     */
    static decodeHeadTail(data) {
        if (data.length % 32 !== 0) {
            throw new Error("Input data length not divisible by 32");
        }
        if (data.length === 0) {
            throw new Error("Input data empty");
        }
        const firstTailPosition = new bn_js_1.default(data.slice(0, 32)).toNumber();
        if (firstTailPosition === 0 || firstTailPosition % 32 !== 0 || firstTailPosition >= data.length) {
            throw new Error("Invalid head length");
        }
        const startPositions = new Array();
        for (let pos = 0; pos < firstTailPosition; pos += 32) {
            const startPosition = new bn_js_1.default(data.slice(pos, pos + 32)).toNumber();
            if (startPosition < firstTailPosition) {
                throw new Error("Found start position inside the header");
            }
            startPositions.push(startPosition);
        }
        const contents = startPositions.map((startPosition, argumentIndex) => {
            const length = startPositions[argumentIndex + 1] !== undefined
                ? startPositions[argumentIndex + 1] - startPosition
                : data.length - startPosition;
            return data.slice(startPosition, startPosition + length);
        });
        return {
            head: startPositions,
            tail: contents,
        };
    }
    static decodeVariableLength(data) {
        if (data.length % 32 !== 0) {
            throw new Error("Input data length not divisible by 32");
        }
        if (data.length === 0) {
            throw new Error("Input data empty");
        }
        const length = new bn_js_1.default(data.slice(0, 32)).toNumber();
        return data.slice(32, 32 + length);
    }
    static padTo32(data) {
        if (data.length > 32) {
            throw new Error("Input data greater than 32 not supported");
        }
        const padding = new Array(32 - data.length).fill(0);
        return new Uint8Array([...padding, ...data]);
    }
}
exports.Abi = Abi;
//# sourceMappingURL=abi.js.map